module.exports = __webpack_public_path__ + "static/media/success_icon.6dce54d0.svg";